import {SimplePageLayout} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {SubscriptionStatusBanner} from "../../../components/SubscriptionStatusBanner.tsx";
import {ApplicationProductsComponent} from "../components/ApplicationProductsComponent.tsx";
import {useApplicationProducts} from "../hooks/useApplicationProducts.ts";
import {useEffect} from "react";

export const IndexPage = () => {

    const {
        items: applicationProducts,
        handleFetchRecords
    } = useApplicationProducts();

    useEffect(() => {
        handleFetchRecords()
    }, []);

    const products = applicationProducts?.map((applicationProduct) => applicationProduct.product);

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >

            {products ?
                <>
                    <SubscriptionStatusBanner/>
                    <ApplicationProductsComponent products={products}/>
                </> : null}

        </SimplePageLayout>
    );
};
